// @flow
// SEO compartido del segmento /asesores.
// Imagen de compartición por defecto (1200x675). Se importa como asset → file-loader
// la publica con content-hash en `${FINECT_STATIC}/...` (URL absoluta, apta para og:image).
import shareImage from '../assets/shareImage.jpg';

const BASE_URL = 'https://www.finect.com';

export const SHARE_IMAGE = shareImage;
export const SHARE_IMAGE_WIDTH = 1200;
export const SHARE_IMAGE_HEIGHT = 675;

const absUrl = (url: ?string): string => {
  if (!url) return BASE_URL;
  return url.startsWith('http') ? url : `${BASE_URL}${url}`;
};

// Bloque openGraph para <Head> (@finect/tabular-components/Head).
export const buildOpenGraph = ({
  title,
  description,
  url,
  image = SHARE_IMAGE,
  type = 'website',
  imageAlt = 'Finect Asesores'
}: Object): Object => ({
  site: 'Finect',
  title,
  description,
  image,
  type,
  url: absUrl(url),
  locale: 'es_ES',
  imageWidth: SHARE_IMAGE_WIDTH,
  imageHeight: SHARE_IMAGE_HEIGHT,
  imageAlt
});

// Bloque twitter para <Head>.
export const buildTwitter = ({ title, description, image = SHARE_IMAGE }: Object): Object => ({
  card: 'summary_large_image',
  site: '@finect',
  title,
  description,
  image
});
